import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProgramLocation } from '../models/client/client-program.interface';
import {
  ClientCreateResponse,
  ClientDataResponse
} from '../models/client/client.interface';

@Injectable({
  providedIn: 'root',
})
export class ProgramService {
  constructor(private http: HttpClient) {}

  createProgram(
    reqBody: any
  ): Observable<ClientDataResponse<ClientCreateResponse>> {
    return this.http.post<ClientDataResponse<ClientCreateResponse>>(
      `${environment.fireStoreApiUrl}/api/v1/program-locations/`,
      reqBody
    );
  }

  getProgramLocations(
    limit: number,
    offSet: number,
    search:string= ''
  ): Observable<ClientDataResponse<any>> {
    let url = `${environment.fireStoreApiUrl}/api/v1/program-locations/?limit=${limit}&offset=${offSet}`;
    if (search) {
      url = `${environment.fireStoreApiUrl}/api/v1/program-locations/?limit=${limit}&offset=${offSet}&search=${search}`;
    }
    return this.http.get<ClientDataResponse<any>>(url);
  }

  getClientProgramLocations(id: number): Observable<ClientDataResponse<ProgramLocation>> {
    return this.http.get<ClientDataResponse<ProgramLocation>>(
      `${environment.fireStoreApiUrl}/api/v1/program-locations/${id}`
    );
  }

  createProgramLocationContact(
    reqBody: any
  ): Observable<ClientDataResponse<ClientCreateResponse>> {
    return this.http.post<ClientDataResponse<ClientCreateResponse>>(
      `${environment.fireStoreApiUrl}/api/v1/program-location-contacts/`,
      reqBody
    );
  }

  getProgramContacts(
    limit: number,
    offSet: number,
    programLocationId?: number
  ): Observable<ClientDataResponse<any>> {
    let url = `${environment.fireStoreApiUrl}/api/v1/program-contacts/?limit=${limit}&offset=${offSet}`;
    if(programLocationId){
      url = `${environment.fireStoreApiUrl}/api/v1/program-contacts/?limit=${limit}&offset=${offSet}&program_location_id=${programLocationId}`
    }
    return this.http.get<ClientDataResponse<any>>(url);
  }

  getPriceList(
    limit: number,
    offSet: number
  ): Observable<ClientDataResponse<any>> {
    return this.http.get<ClientDataResponse<any>>(
      `${environment.fireStoreApiUrl}/api/v1/price-list-custom/?limit=${limit}&offset=${offSet}`
    );
  }

  createProgramContact(
    reqBody: any
  ): Observable<ClientDataResponse<ClientCreateResponse>> {
    return this.http.post<ClientDataResponse<ClientCreateResponse>>(
      `${environment.fireStoreApiUrl}/api/v1/program-contacts/`,
      reqBody
    );
  }
}
